import { FlexCol } from '@/components/common/Flex';
import Modal from '@/components/common/modals/Modal';
import ModalManager, { useModal } from '@/components/ModalManager';
import { FlexProps } from '@chakra-ui/react';
import { ThemingProps } from '@chakra-ui/styled-system';
import { IconButton, IconButtonProps } from './Button';
import { InfoCircle } from './icons';
import { Subheader } from './Typography';

export interface InfoButtonWithModalProps extends InfoModalProps {
    buttonProps: Omit<
        IconButtonProps,
        'aria-label' | 'onClickEvent' | 'onClickEventParams'
    > & {
        onClickEventParams: IconButtonProps['onClickEventParams'] & {
            location: string;
        };
    };
}

export const InfoButtonWithModal = ({
    buttonProps: { onClickEventParams, ...buttonProps },
    title,
    ...props
}: InfoButtonWithModalProps) => {
    return (
        <InfoIconButton
            {...buttonProps}
            onClick={(e) => {
                e.stopPropagation();
                showInfoModal({ title, ...props });
            }}
            onClickEvent="Info Button Clicked"
            onClickEventParams={{ ...onClickEventParams, title }}
        />
    );
};

export const InfoIconButton = ({
    ...props
}: Omit<IconButtonProps, 'aria-label'>) => {
    return (
        <IconButton
            variant="ghost"
            colorScheme="gray"
            size="xs"
            icon={<InfoCircle size="sm" />}
            aria-label="info"
            {...props}
        />
    );
};

export interface InfoModalProps extends FlexProps {
    title: string;
    modalSize?: ThemingProps['size'];
}

export const showInfoModal = (props: InfoModalProps) =>
    ModalManager.show(InfoModal, props);

export const InfoModal = ModalManager.create<InfoModalProps>(
    ({ children, title, modalSize = 'md', ...props }) => {
        const modal = useModal();

        return (
            <Modal
                size={modalSize}
                isOpen={modal.visible}
                onClose={modal.remove}
            >
                <FlexCol {...props}>
                    <Subheader mb={8}>{title}</Subheader>
                    <FlexCol gap={6}>{children}</FlexCol>
                </FlexCol>
            </Modal>
        );
    }
);
